import "@hotwired/turbo-rails";
import "bootstrap";

const trackPageView = () => {
  const page = `${window.location.pathname}${window.location.search}`;

  if (window.ga) {
    window.ga("set", "page", page);
    window.ga("send", "pageview");
  }

  if (window.fbq) {
    window.fbq("track", "PageView");
  }

  if (window._hmt) {
    window._hmt.push(["_trackPageview", page]);
  }
};

document.addEventListener("turbo:load", trackPageView);
